import { render, staticRenderFns } from "./ActivateSubscription.vue?vue&type=template&id=2b473ed2&scoped=true"
import script from "./ActivateSubscription.vue?vue&type=script&lang=js"
export * from "./ActivateSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b473ed2",
  null
  
)

export default component.exports